/** Контакты специалиста для sales MVP (env VUE_APP_SALES_*). */
export const salesContacts = {
  telegramUrl: process.env.VUE_APP_SALES_TELEGRAM_URL || 'https://t.me/neyrosvet',
  phoneTel: process.env.VUE_APP_SALES_PHONE || '+79533416548',
  phoneDisplay: process.env.VUE_APP_SALES_PHONE_DISPLAY || '+7 (953) 341-65-48',
  email: process.env.VUE_APP_SALES_EMAIL || 'Ai@neyrosvet.ru',
  specialistHint: 'На старте мы поможем настроить подбор тендеров под вашу компанию',
}
